export function mobileMenu() {
    const trigger = document.getElementById('open-mobile-menu');
    const nav = document.querySelector('.nav');
    const overlay = document.querySelector('.page-overlay-nav');

    if (trigger && nav && overlay) {
        trigger.onclick = () => {
        trigger.classList.toggle('hamburger--active');
        nav.classList.toggle('nav--active');
        overlay.classList.toggle('page-overlay--active');
        };
    }
}

export function closeMobileMenu() {
    document.getElementById('open-mobile-menu')?.classList.remove('hamburger--active');
    document.querySelector('.nav')?.classList.remove('nav--active');
    document.querySelector('.page-overlay-nav')?.classList.remove('page-overlay--active');
}